import { defineComponent as _defineComponent } from 'vue'
import { formatStripePrice } from "@/helpers/transformation/price";
  import { computed } from "vue";
  import { CustomTerms } from "@/types/CustomTerms";

  interface Props {
    message: string;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'InfoMessage',
  props: {
    message: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

const __returned__ = { props, get formatStripePrice() { return formatStripePrice }, computed, get CustomTerms() { return CustomTerms } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})